import { Field, Int, ObjectType } from '@nestjs/graphql'

@ObjectType()
export class ArcTeamAutoActionDto {
  @Field(type => Int)
  id!: number

  @Field()
  emailAddress!: string

  @Field(type => Int)
  type!: number
}
